import { useRef } from "react"
import { NpButton } from "src/components/np-design/components/NpButton"
import { NpInput } from "src/components/np-design/components/input/NpInput"

export type SearchFormProps = {
  value: string
  onChange: (value: string) => void
}

export const SearchForm = ({ value, onChange }: SearchFormProps) => {
  const ref = useRef<HTMLInputElement>(null)

  return (
    <form
      role="search"
      className="relative"
      onSubmit={(event) => {
        event.preventDefault()
        ref.current?.blur()
      }}
    >
      <NpInput
        ref={ref}
        type="search"
        placeholder="Suchen..."
        autoComplete="off"
        value={value || ""}
        onChange={onChange}
      />

      <div className="absolute top-0 right-0 bottom-0 flex items-center p-1">
        {value && (
          <NpButton
            iconNameLeft="close"
            variant="ghost"
            color="gray75"
            size="sm"
            onClick={() => onChange("")}
            title="Suche zurücksetzen"
          />
        )}
      </div>
    </form>
  )
}
